import { useMemo } from 'react';

import { defaultGetFilteredItems, defaultLabelGetter } from '../helpers';
import { GenericItem, GetFilteredItems, ItemToString } from '../types';

type UseFilteredItemsProps<TItem extends GenericItem> = {
  items: TItem[];
  itemToString?: ItemToString<TItem>;
  getFilteredItems?: GetFilteredItems<TItem>;
  inputValue?: string;
  filterBy?: (item: string, inputValue: string) => boolean;
};

export default <TItem extends GenericItem>({
  items,
  itemToString = defaultLabelGetter,
  getFilteredItems = defaultGetFilteredItems,
  inputValue,
  filterBy,
}: UseFilteredItemsProps<TItem>) => {
  const filteredItems = useMemo(
    () =>
      getFilteredItems({
        inputValue: inputValue || '',
        itemToString,
        allItems: items,
        filterBy,
      }),
    [filterBy, getFilteredItems, inputValue, itemToString, items],
  );

  return {
    filteredItems,
  };
};
